<template>
    <b-dropdown class="dropdown" style="width:100%" >
      
        <div class="dropdown-button" slot="trigger">
          {{dropdown.defaultText || 'Please Select'}}
            <b-icon pack="md" class="menu-down" icon="arrow_drop_down"></b-icon>
<v-icon right medium class="menu-down" color="gray">arrow_drop_down</v-icon>
            
        </div>

        <b-dropdown-item class="dropdown-item" v-for="(tag) in dropdown.items" :key="tag.id" :value="tag.value" @click="onTagClicked(tag.value, tag.type)">
            <div :class="getDropdownIconClass(tag.type)" style="position:absolute;width:10px;height:10px;margin: 4px 10px 4px 0px;">
                        </div>
            
            {{tag.value}}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
export default {
  name: 'Dropdown',
  props: [
      'dropdown'
  ],
  computed: {
    selectionText () {
      return this.$store.state.selectionText
    },
    isDisabled () {
      return !this.selectionText
      //:disabled="isDisabled"
    }
  },
  methods: {
    onTagClicked (value, type){
      var id = this.getUniqueID();
      this.dropdown.defaultText = value;
      this.dropdown.selection = {value: '', type:type}
    },
    getDropdownIconClass (type){
      if(typeof type !== 'undefined'){
        return 'highlight-'+type;
      } else{
        return ''
      }
    }

  }
}
</script>

<style scoped>

.dropdown{
  cursor: pointer;
}

.dropdown-item{
  z-index: 1000;
}

.dropdown-menu .dropdown-item{
  text-align: center;
}
.dropdown-button{
      border: 1px solid lightgray;
    border-radius: 0px;
    /* height: 25px; */
    line-height: 25px;
    padding: 5px;
}


.menu-down{
  position: absolute;
    right: 20px;
    top: 8px;
}

a.dropdown-item.is-active{
  background-color: #e9f7fe;
  color:gray;
}
</style>

<style>

.dropdown-item{
  font-size: 14px!important;
}
</style>